var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({paddingTop: _vm.padding + 'px',paddingBottom: _vm.padding + 'px'}),attrs:{"id":"null"}},[_c('img',{staticClass:"bg",style:({width: _vm.width + 'px'}),attrs:{"src":"/en/static/image/null.png"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cbeb291","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/score-null.vue
// module id = null
// module chunks = 